import type { Specialty } from '../data/types';
import type {CatalogPreview} from '../data/preview';
export interface LocalState { schemaVersion:1; favorites:string[]; specialty:Specialty|null; recentCodes:{id:string;count:number;lastUsed:number}[]; recentQueries:string[]; initialized:boolean;preview?:CatalogPreview }
export const emptyState=():LocalState=>({schemaVersion:1,favorites:[],specialty:null,recentCodes:[],recentQueries:[],initialized:false});
const DB='codalia-local-v1';
function openDB():Promise<IDBDatabase> {
  return new Promise((resolve,reject)=>{
    const request=indexedDB.open(DB,1);
    request.onupgradeneeded=()=>request.result.createObjectStore('local');
    request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);
  });
}
export async function readLocal():Promise<LocalState> {
  const db=await openDB();
  try {return await new Promise((resolve,reject)=>{const req=db.transaction('local').objectStore('local').get('state');req.onsuccess=()=>{
    const s=req.result;if(!s)return resolve(emptyState());
    // Never treat a newer or unknown schema as an empty installation: the
    // startup defaults could otherwise overwrite data written by a newer app.
    if(s.schemaVersion!==1)return reject(new Error('Versione dei dati locali non supportata'));
    if(!Array.isArray(s.favorites)||!Array.isArray(s.recentCodes)||!Array.isArray(s.recentQueries))return reject(new Error('Dati locali non leggibili'));
    resolve(s);
  };req.onerror=()=>reject(req.error);});}finally{db.close();}
}
export async function writeLocal(state:LocalState) {
  const db=await openDB();try{await new Promise<void>((resolve,reject)=>{
    const tx=db.transaction('local','readwrite');tx.objectStore('local').put(state,'state');tx.oncomplete=()=>resolve();tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);
  });}finally{db.close();}
}
// A fixed boolean, separate from personal data. The read/write transaction
// serializes claims across tabs; clearing favorites or recent codes keeps it.
export async function claimFirstUseCount():Promise<boolean> {
  const db=await openDB();
  try {return await new Promise<boolean>((resolve,reject)=>{
    const tx=db.transaction('local','readwrite'),store=tx.objectStore('local');
    let claimed=false;
    const request=store.get('first-use-count-v1');
    request.onsuccess=()=>{if(request.result===undefined){store.put(true,'first-use-count-v1');claimed=true;}};
    tx.oncomplete=()=>resolve(claimed);
    tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);
  });}finally{db.close();}
}
export function recordUse(state:LocalState,id:string,query:string|null):LocalState {
  const prior=state.recentCodes.find(r=>r.id===id);
  return {...state,recentCodes:[{id,count:(prior?.count||0)+1,lastUsed:Date.now()},...state.recentCodes.filter(r=>r.id!==id)].slice(0,20),recentQueries:query?[query,...state.recentQueries.filter(q=>q!==query)].slice(0,8):state.recentQueries};
}
